export enum IdentityType {
  IDCARD = 'IDCARD',
  PASSPORT = 'PASSPORT'
}
